import { useEffect, useState } from 'react';
import {getProjById} from "../requests/exportRequests";

export function useProjectForNav(api, navProject, projId) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [proj, setProj] = useState(null);

  const getProj = async (id) => {
    await setLoading(true);
    if (id) {
      const resProj = getProjById(api,id)
      if (resProj.error) {
        setError(resProj.error);
        setLoading(false);
        return;
      }

      // eslint-disable-next-line react-hooks/rules-of-hooks
      useEffect(() => {
        const fetchProj = async () => getProj(projId);
        fetchProj()
        // eslint-disable-next-line no-console
          .catch(console.error);
      }, []);

      navProject.setStratTitle(resProj.strategy.name);
      navProject.setPortfolioTitle(resProj.portfolio.name);
      navProject.setPortfProjTitle(resProj.name);

      setProj({
        ...resProj,
        startDate: resProj.startDate ? resProj.startDate.substring(0, 10) : undefined,
        endDate: resProj.endDate ? resProj.endDate.substring(0, 10) : undefined,
        approvedOn: resProj.approvedOn ? resProj.approvedOn.substring(0, 10) : undefined,
      });
    } else {
      const resStrat = await api.get('/mng/strategies?short=true');
      const strategyName = proj?.strategyId ? resStrat.find((s) => s.id === parseInt(proj.strategyId)).name : '';

      navProject.setProjTitle('Новый проект');
      navProject.setStratTitle(strategyName);

      setProj({
        ...proj,
        strategyName,
      });
    }
    await setLoading(false);
  };
  return proj;
}
